import { useShareJobMutation } from './useShareJobMutation';

export const useOnShareOnPlatformPressed = () => {
  const shareJobMutate = useShareJobMutation();

  return ({ id, platform }) => {
    shareJobMutate({ jobId: id, platform });
  };
};
